module.exports = __webpack_public_path__ + "img/tipocontacto08.2106fa7.svg";